import React, {useState} from 'react';
import { useSelectable, SelectableBar } from '../../Components/Selectable';
import ScheduleMany from './ScheduleMany';
import DoneMany from './DoneMany';
import SkipMany from './SkipMany';
import AddToRoundMany from './AddToRoundMany';

const MassActions = ({refresh, className, sticky}) => {
    const [massActioning, setMassActioning] = useState(null);
    const {selectNone, toggleIsSelecting} = useSelectable();

    return <>
        <SelectableBar className={className}
            options={[
                {title: 'Schedule jobs', icon: 'CalendarPlus', onClick: () => setMassActioning('schedule')},
                {title: 'Mark all as done', icon: 'Check', onClick: () => setMassActioning('done')},
                {title: 'Skip jobs', icon: 'Forward', onClick: () => setMassActioning('skip')},
                {title: 'Add to round', icon: 'Route', onClick: () => setMassActioning('addToRound')},
                {div: true},
                {title: 'Stop selecting', icon: 'SquareCheck', onClick: toggleIsSelecting},
            ]}
            sticky={sticky}
            hideWhenNotSelecting
        />

        <ScheduleMany isOpen={massActioning === 'schedule'} onClose={() => setMassActioning(null)} then={() => { selectNone(); refresh(); }} />
        <DoneMany isOpen={massActioning === 'done'} onClose={() => setMassActioning(null)} then={() => { selectNone(); refresh(); }} />
        <SkipMany isOpen={massActioning === 'skip'} onClose={() => setMassActioning(null)} then={() => { selectNone(); refresh(); }} />
        <AddToRoundMany isOpen={massActioning === 'addToRound'} onClose={() => setMassActioning(null)} then={() => { selectNone(); refresh(); }} />
    </>
}

export default MassActions;
